/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".info-modal .info-body{width:100%;max-height:450px;min-height:55px;overflow-y:auto;text-align:left;padding:16px 0}.info-modal .info-body .cancel-btn{margin-top:24px}"];
export { styles as styles };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/show.info.modal/show.info.modal.component.scss.ngstyle.js.pre-build-optimizer.js